const prefix = 'task_h5_';
export const storage = {
  get(key: string) { try { return localStorage.getItem(prefix + key); } catch { return null; } },
  set(key: string, value: string) { try { localStorage.setItem(prefix + key, value); } catch { /* quota/private mode */ } },
  remove(key: string) { try { localStorage.removeItem(prefix + key); } catch { /* unavailable */ } },
};
